/* Khung ký tay (ngón tay / bút / chuột) — dùng cho khách ở form khai báo và bác sĩ ở bước Bác sĩ khám; lưu dạng ảnh PNG data URL */
import React, { useEffect, useRef } from 'react';
import { Eraser } from 'lucide-react';

export default function SignaturePad({ value, onChange, className = 'h-[160px]', hint = 'Ký bằng ngón tay hoặc bút trong khung' }: {
  value?: string;
  onChange: (x?: string) => void;
  /** Chiều cao khung */
  className?: string;
  hint?: string;
}) {
  const ref = useRef<HTMLCanvasElement>(null);
  const drawing = useRef(false);
  const ctx = () => ref.current?.getContext('2d');
  // Vẽ lại chữ ký đã có (quay lại sửa form) và đặt độ phân giải theo khung
  useEffect(() => {
    const c = ref.current;
    if (!c) return;
    const r = c.getBoundingClientRect();
    c.width = r.width * 2;
    c.height = r.height * 2;
    const g = c.getContext('2d')!;
    g.scale(2, 2);
    g.lineWidth = 2.2;
    g.lineCap = 'round';
    g.strokeStyle = '#0f172a';
    if (value) { const img = new Image(); img.onload = () => g.drawImage(img, 0, 0, r.width, r.height); img.src = value; }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const pos = (e: React.PointerEvent) => {
    const r = ref.current!.getBoundingClientRect();
    return [e.clientX - r.left, e.clientY - r.top] as const;
  };
  return (
    <div>
      <canvas ref={ref} className={`w-full touch-none rounded-xl border-2 border-dashed border-gray-300 bg-gray-50 ${className}`}
        onPointerDown={(e) => { drawing.current = true; ref.current!.setPointerCapture(e.pointerId); const [x, y] = pos(e); ctx()!.beginPath(); ctx()!.moveTo(x, y); }}
        onPointerMove={(e) => { if (!drawing.current) return; const [x, y] = pos(e); ctx()!.lineTo(x, y); ctx()!.stroke(); }}
        onPointerUp={() => { drawing.current = false; onChange(ref.current!.toDataURL('image/png')); }} />
      <div className="mt-1.5 flex items-center justify-between text-xs text-gray-500">
        <span>{hint}</span>
        <button type="button" className="flex items-center gap-1 text-[#092C23] dark:text-gray-300" onClick={() => {
          const c = ref.current!;
          ctx()!.clearRect(0, 0, c.width, c.height);
          onChange(undefined);
        }}><Eraser size={13} />Ký lại</button>
      </div>
    </div>
  );
}
